'use client';
import { Button } from '@heroui/react';

import Header from '@/components/header-new';
import localStorage from '@/src/local-storage'

const Unauthenticated = () => {
  return (<>
    <Header section='' page='Unauthenticated' />
      <div className='grow bg-chTan-200 md:ml-[300px] mt-24 mb-20'>
        <div className='md:max-w-[960px] md:mx-auto px-4'>
          <div className='flex flex-col items-center justify-center'>
            <div className='text-2xl font-bold'>Please sign in to access this page.</div>
            <Button 
              color='primary'
              className='mt-4' 
              onPress={() => {
                if (window.ReactNativeWebView) {
                  window.ReactNativeWebView?.postMessage(JSON.stringify({ signout: true }))
                } else {
                  localStorage.setRedirect(window.location.pathname)
                  window.location.href = `/signin?redirect=${encodeURIComponent(window.location.pathname)}`
                }
              }}
              >
              Sign In
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Unauthenticated;
